// Costruzione del payload di una pageview (web analytics cookieless). Campi
// snake_case, come il resto del contratto wire (closeyourit-docs/API.md §4.4).
// NESSUN segnale identificante viaggia nel body: IP e User-Agent li ricava il
// server dalla richiesta; della query viaggiano SOLO le 3 chiavi UTM (mai la
// query intera). `path` è sempre privo di query string. `environment` è aggiunto
// dal client all'invio (è lui a conoscere l'ambiente risolto).
//
// Assume un contesto browser: l'unico chiamante, `Client.capturePageview`, gata
// su `isBrowser()` prima di invocarla — una pageview fuori dal browser non ha
// senso (niente location/referrer/UTM). Nessuna guardia non-browser qui: sarebbe
// codice morto irraggiungibile sotto jsdom.

import { uuidV4 } from './uuid'

/// Payload di una pageview pronto per l'invio, SENZA `environment` (lo aggiunge
/// il client). `referrer` e gli `utm_*` sono presenti solo se valorizzati.
export interface PageviewPayload {
  event_id: string
  hostname: string
  path: string
  referrer?: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  occurred_at: string
}

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'] as const

/// Costruisce la pageview dalla location corrente. [overrides.path] forza il
/// path (default `location.pathname`, MAI la query). `event_id` è un UUID v4 (con
/// trattini) per l'idempotenza `(project_id, event_id)`.
export function buildPageview(overrides: { path?: string } = {}): PageviewPayload {
  const payload: PageviewPayload = {
    event_id: uuidV4(),
    hostname: location.hostname,
    path: overrides.path ?? location.pathname,
    occurred_at: new Date().toISOString(),
  }

  if (document.referrer) payload.referrer = document.referrer

  const params = new URLSearchParams(location.search)
  for (const key of UTM_KEYS) {
    const value = params.get(key)
    if (value) payload[key] = value
  }

  return payload
}
